<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>Standard 1</h3>
        </div>
    </div>
</header>
<main>
    <div class="standard-list standard-details">
        <div class="main-members">
            <div class="member-list-item">
                <div>
                    <h5>Desai Nirav Pankajbhai</h5>
                    <h6>Surat</h6>
                    <p>100.00</p>
                </div>
            </div>
            <div class="member-list-item">
                <div>
                    <h5>Desai Nirav Pankajbhai</h5>
                    <h6>Surat</h6>
                    <p>97.75</p>
                </div>
            </div>
            <div class="member-list-item">
                <div>
                    <h5>Desai Nirav Pankajbhai</h5>
                    <h6>Surat</h6>
                    <p>80.30</p>
                </div>
            </div>
            <div class="member-list-item">
                <div>
                    <h5>Desai Nirav Pankajbhai</h5>
                    <h6>Surat</h6>
                    <p>75.00</p>
                </div>
            </div>
        </div>
    </div>
</main>